export class Constants {

    public static SuccessTitle: any = "Success";
    public static ErrorTitle: any = "Error";
    public static WarningTitle: any = "Warning";

    public static SuccessType: any = "success";
    public static ErrorType: any = "error";
    public static WarningType: any = "warning";

    public static RecordAddTitle: any = "Record Added Successfully";
    public static RecordUpdateTitle: any = "Record Updated Successfully";
    public static RecordDeleteTitle: any = "Record Deleted Successfully";
    public static RecordLimit: any = 10;
    // public static BUS_OPERATOR_ID: any = 1;

    // FOR LIVE
    // public static BASE_URL: any = 'https://provider.odbus.co.in/api';
    // public static CONSUMER_API_URL: any = 'https://consumer.odbus.co.in/api/';
    // public static PATHURL: any = 'https://provider.odbus.co.in/public/uploads/';

    // FOR LOCAL
    // public static BASE_URL: any = 'http://localhost:7001/ODBUS/odbusproviderbe/api';
    // public static CONSUMER_API_URL: any = 'http://localhost:7001/ODBUS/odbusconsumerbe/api/';
    // public static PATHURL: any = 'http://localhost:7001/ODBUS/odbusproviderbe/public/uploads/';

    // FOR TESTING
    public static BASE_URL:any ='https://odapi.adglob.in/api';
    public static CONSUMER_API_URL:any ='https://odclient.adglob.in/api/';
    public static PATHURL:any = 'https://odapi.adglob.in/public/uploads/';
}